<template>
  <div class="timeline-wrapper">
    <div class="timeline">
      <div
        v-for="(step, idx) in values"
        :key="idx"
        class="timeline__item"
        :class="{
          active: Number(currentStep) >= idx + 1,
          current: Number(currentStep) === idx,
        }"
      >
        <div class="timeline__point">{{ idx + 1 }}</div>
        <div class="timeline__item-content">{{ step.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['values', 'currentStep'],
}
</script>

<style scoped>
.timeline-wrapper {
  display: block;
  max-width: 960px;
}

.timeline {
  display: flex;
  position: relative;
  max-width: 800px;
  width: 100%;
  height: 40px;
  justify-content: space-between;
  margin: auto;
}
.timeline::after {
  display: block;
  content: '';
  width: 100%;
  position: absolute;
  border-top: 3px solid #409eff;
  margin-top: -3px;
  top: 50%;
  z-index: -1;
}
.timeline__point {
  border: 2px solid #e4e7ed;
  border-radius: 50%;
  background: #e4e7ed;

  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeline__item.active::after {
  border-color: #409eff;
}
.timeline__item .timeline__point {
  color: #fff;
  border-color: #409eff;
  background-color: #409eff;
}
.timeline__item.current .timeline__point {
  font-weight: bold;
  color: #000;
  border-color: #000;
  background-color: #fff;
}
.timeline__item-content {
  margin-top: 15px;
  margin-left: -15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/Timeline.vue